import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { CANCEL_LABEL, OK_LABEL } from '@common/constants';
import { IConfirmationDialogData } from 'src/app/core/models/dialog.model';
import { CBXDialogData } from '../../services/dialog/dialog.service';
import { Data } from 'src/app/DataService';
import { Router } from '@angular/router';
import { ProcessShellService } from 'src/app/process-shell/services/process-shell.service';
import { CustomerdedupeService } from 'src/app/dedupe/customerdedupe-service/customerdedupe.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.scss']
})
export class ConfirmationDialogComponent implements OnInit, OnDestroy {

  // okLabel:string = "";
  // cancelLabel:string = "";
  // title:string = "";
  // message:string = "";
  openedAsScreen: boolean;

  constructor(
    private dialogRef: MatDialogRef<ConfirmationDialogComponent>,
    private _dataStore: Data,
    @Inject(MAT_DIALOG_DATA) protected data: CBXDialogData,
    private _router: Router,
    private _customerdedupeService: CustomerdedupeService
  ) {
    if(this._router.getCurrentNavigation()?.extras?.queryParams) {
      this.data = this._router.getCurrentNavigation()?.extras?.queryParams;
      this.openedAsScreen = true;
      document.body.classList.add('confirmation-screen');
    }
   }

  ngOnInit(): void {
    
  }

  ngOnDestroy(): void {
    document.body.classList.remove('confirmation-screen');
  }

  shareInfo(data) {
    this._dataStore.shareInfo(data, "reference number copied on clipboard!");
  }

  ok(){
    if(this.openedAsScreen) {
      this._customerdedupeService.continueApplication.emit(1)
    }
    else this.dialogRef?.close(1);
  }

  cancel(){
    if(this.openedAsScreen) {
      this._customerdedupeService.continueApplication.emit(0)
    }
    else this.dialogRef?.close(2);
  }

}
